// 화면 17 — 섹터 스코어 재산정 REST 어댑터.
// 권위: 사용자 결정 2026-05-15. 백엔드 병렬 PR 명세:
//   POST /api/v1/sectors/recompute      → 202 (SectorRecomputeAck) | 409 (active job 충돌)
//   GET  /api/v1/sectors/recompute/status → SectorRecomputeStatus { activeJob, lastCompletedJob }
// 응답은 ApiResponse.ok(data) 래퍼 — client.ts interceptor 가 data 만 언랩.

import { apiGet, apiPost } from './client';

export interface SectorRecomputeRequest {
  lookbackDays: number;
  startDate?: string;
  endDate?: string;
  triggeredBy?: string;
  /**
   * 전체 reset 모드 — true 면 daily_sector_history 전체 DELETE 후
   * stock_daily_score 가 존재하는 모든 거래일에 대해 재산정.
   * sector mapping 변경(자식 비활성화 등) 후 과거 잔재 정리 용도.
   * 기본 false.
   */
  fullReset?: boolean;
  /**
   * 주도주 (leader_stocks_daily) 도 함께 재산출.
   * 섹터 머지/매핑 변경 후 leader_stocks 가 새 매핑 기준으로 재산출되도록 함.
   * 소요 시간 5~10분 증가. 기본 false.
   */
  recomputeLeaderStocks?: boolean;
}

export interface SectorRecomputeAck {
  jobId: string;
  status: string; // "queued" | "running"
  startDate: string;
  endDate: string;
  lookbackDays: number;
  estimatedDurationSeconds: number;
}

export interface SectorRecomputeJob {
  jobId: string;
  status: 'queued' | 'running' | 'completed' | 'failed' | string;
  lookbackDays: number;
  startDate: string;
  endDate: string;
  processed: number;
  total: number;
  currentDate: string | null;
  etaMs: number | null;
  triggeredBy: string | null;
  startedAt: string | null;
  finishedAt: string | null;
  errorMessage: string | null;
}

export interface SectorRecomputeStatus {
  activeJob: SectorRecomputeJob | null;
  lastCompletedJob: SectorRecomputeJob | null;
}

export async function postSectorRecompute(
  body: SectorRecomputeRequest
): Promise<SectorRecomputeAck> {
  return apiPost<SectorRecomputeAck>('/api/v1/sectors/recompute', body);
}

export async function getSectorRecomputeStatus(): Promise<SectorRecomputeStatus> {
  return apiGet<SectorRecomputeStatus>('/api/v1/sectors/recompute/status');
}
